var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", { staticClass: "subHeader" }, [
    _c("div", { staticClass: "content-header" }, [_vm._v("DRAFTS")]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "group-button-sub-header" },
      [
        _c("ButtonCreateNewEvent", {
          staticClass: "float-left",
          attrs: { item: _vm.btnSubmitAllEvent }
        }),
        _vm._v(" "),
        _c("ButtonCreateNewEvent", {
          staticClass: "float-right",
          attrs: { item: _vm.btnCreateEvent }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-body" }, [
      _c("a", [
        _vm._v(" Create new events and submit them to ADURO for approval. ")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-07ca3afa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07ca3afa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/subHeaders/SubHeaderDraft.vue
// module id = 1879
// module chunks = 1